import { readPendingOtp } from '@/lib/otp-pending';

const STORAGE_KEY = 'jeraisonne_decouverte_vue';

/** « Vu » pendant cette exécution, même si localStorage refuse l'écriture (pas de boucle login ↔ découverte). */
let seenThisRun = false;

/**
 * Le carrousel de découverte (`/decouverte`) n'est montré qu'au premier lancement.
 *
 * Si localStorage est inaccessible (Safari en navigation privée), on répond
 * `true` : impossible de mémoriser « vu », donc répondre `false` enfermerait
 * l'utilisateur dans le carrousel à chaque passage par `/`. La découverte est un
 * confort, pas une étape obligatoire — elle dégrade vers `/login`.
 */
export function hasSeenDecouverte(): boolean {
  if (typeof window === 'undefined' || seenThisRun) return true;
  try {
    return window.localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return true;
  }
}

export function markDecouverteSeen(): void {
  seenThisRun = true;
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, '1');
  } catch {
    /* Silencieux — localStorage peut être désactivé. */
  }
}

/**
 * `/login` sur un navigateur ou une app qui n'a jamais vu la présentation : on la montre d'abord.
 * Pas si un code de connexion est en attente (retour de la boîte mail : il faut retrouver l'écran du code).
 */
export function shouldShowDecouverteBeforeLogin(): boolean {
  return !hasSeenDecouverte() && readPendingOtp() === null;
}

/** Tests uniquement. */
export function resetDecouverteSeenForTests(): void {
  seenThisRun = false;
}
